exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".goods-detail .image-upload-tip[data-v-3cc7a2d0]{margin-bottom:8px;padding:4px 10px}.goods-detail .image-upload-tip[data-v-3cc7a2d0]  .el-alert__icon{font-size:14px;width:14px}.goods-detail .image-upload-tip[data-v-3cc7a2d0]  .el-alert__title{font-size:12px;line-height:1.4}.goods-detail .editer[data-v-3cc7a2d0]  .mce-tinymce{-webkit-box-sizing:border-box;box-sizing:border-box}", ""]);

// exports
